var e=Symbol();function r(){var r,n,o=new Promise((function(e,o){r=e,n=o}));return o.resolve=r,o.reject=n,o[e]=1,o}export{r as deferred};
